
import {ElLoading} from "element-plus";

type column = {
    prop: String;
    label: String;
    width: Number;
};

type parts = {
    name: string;
    mountings_type_pname: string;
    mountings_type_name: string;
    cost_price: number | null;
    selling_price: number | null;
    price_lock: number;
    mountings_brand_name: string;
    specification: string;
    mountings_unit_name: string;
    build_bonus_type: number;
    build_bonus_price: number | null;
    sell_bonus_type: number;
    sell_bonus_price: number | null;
    reappearance_type_name: string;
    describe: string;
    id: number;
};
const columnList: Array<column> = [];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch, nextTick,
} from "vue";
import {
    getManagementTable, permissionList,
} from "@/api/http";



import {Request} from '@/api/request';
import { validateInput, validateClass } from "@/assets/js/formRules";
import { partsFormType } from "@/assets/types/common";
import { useRoute, useRouter } from 'vue-router'
import {getFirstNowLastDay} from "@/api/date";
export default defineComponent({
    name: "cardSell",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(['套餐销售']);
        const headClass = inject("headClass");
    
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<any>),
            total = ref(0),
            loading = ref(false),
            route:any = useRoute(),
            Router:any = useRouter(),
            form = reactive({
            
            }),
            form_rules:any = {
                //fixed_name: {required: true, message: '必填', trigger: 'blur'},
            },
            screenParameter = reactive({
            
            });
        let handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                // let mydata = {
                //     type:1,
                //     role_name:'incomelist',
                // };
                // permissionList(mydata).then((res:any)=>{
                //     roleList.value = res?.content?.list || 0;
                // });
                //let start_time = screenParameter.value.time?Math.floor(new Date(screenParameter.value.time[0]).getTime()/1000):"";
                //let end_time = screenParameter.value.time ?Math.floor((new Date(screenParameter.value.time[1]).getTime()+24*60*60*1000-1)/1000):"";
                // Request.axiosInstance({
                //     url: 'adminapi/Bookkeeping/incomeList',
                //     data: {
                //         ...screenParameter.value,
                //         page: currentPage.value,
                //         pagesize: pageSize.value,
                //         start_time:start_time,
                //         end_time:end_time
                //     }
                // }).then((res: any) => {
                //     tableData.value = res?.content?.list || [];
                //     loading.value = false;
                //     total.value = res?.content?.total || 0;
                //     selectList.value.totalPrice = res?.content?.price_total;
                // })
            
            },
            getSummaries = (param:any) => {
                const { columns, data } = param;
                const sums: any = [];
                const propArr = [
                    "output_value",
                    "build_yj",
                    "build_bonus_price"
                ];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "合计";
                        return;
                    }
                    const values = data.map((item: any) =>
                        Number(item[column.property])
                    );
                    if (
                        propArr.findIndex((item: any) => {
                            return item == column.property;
                        }) > -1
                    ) {
                        // 增加合计项
                        if (column.property == "output_value") {
                            //sums[index] = selectList.value.total_outputvalue;
                        } else if (column.property == "build_yj") {
                           // sums[index] = selectList.value.total_yj;
                        } else if (column.property == "build_bonus_price") {
                           // sums[index] = selectList.value.total_commission;
                        }
                        if(column.property == "number"){
                            sums[index] = `${sums[index]}`;
                        }else{
                            sums[index] = `¥${sums[index]}`;
                        }
                    } else {
                        sums[index] = "";
                    }
                });
                return sums;
            };
        
        onMounted(() => {
        
        });
        
        return {
            columnList,
            headClass,
            pageSize,
            currentPage,
            tableData,
            total,
            loading,
            screenParameter,
            form,
            form_rules,
            getSummaries,
            getTableData,
            handleCurrentChange,
            handleSizeChange
        };
    },
});
